<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button type="primary" @click="startCreate()" size="mini">申请刻制/销毁印章</el-button>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId" placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="sealName" label="印章名称">
      </el-table-column>
      <el-table-column prop="sealNum" label="枚数" width="50px" align="center">
      </el-table-column>
      <el-table-column label="类型" width="50px">
        <template slot-scope="scope">
          {{ scope.row.type==0?'刻制':'销毁' }}
        </template>
      </el-table-column>

      <el-table-column label="申请人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.flow.creator'></user-info>
        </template>
      </el-table-column>

      <el-table-column prop="applyTime" label="申请时间" width="90px">
      </el-table-column>
      <el-table-column label="审批状态" width="90px">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>

      <el-table-column label="详情" width="130px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="projectDetail(scope.row.flow.applyId, '1')"
            plain>点击查看详情</el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="110px">
        <template slot-scope="scope">

          <span v-if="(scope.row.flow.status == '进行中'||scope.row.flow.status == '已拒绝'||scope.row.flow.status == '已取消')">
            <el-tooltip class="item" effect="dark" content="修改该审批" placement="bottom">
              <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="getRouterLink(scope.row)"></i>
            </el-tooltip>
            <cancel-flow :flow="scope.row.flow" @getLists='getLists'></cancel-flow>
          </span>


          <div v-if="backRole('SM_4')">
            <el-button v-if="scope.row.flow.status=='审批通过' && !scope.row.confirm" type="success" plain size="mini"
              @click="sealUse(scope.row)">{{
              scope.row.type==0?'确认刻制入库':'确认销毁'}}</el-button>
            <!-- <span v-else>/</span> -->
          </div>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import CancelFlow from '@/components/CancelFlow'
  import projectInfo from '@/page/user/projectInfo'
  import approvalType from '@/Mixins/approvalType'

  import UserInfo from '@/components/UserInfo'
  import ApprovalStatus from '@/components/ApprovalStatus'
  import Role from '@/Mixins/role'
  export default {
    components: {
      UserInfo,
      projectInfo,
      ApprovalStatus,
      CancelFlow,
    },
    mixins: [approvalType, Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        noSelectOrganization: true,

        organizationListData: [],
        depId: '',
        addMeetingRoomStatus: false,

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.depId == "7") {
        this.noSelectOrganization = false
        // this.depId = 0
      }

      this.getLists()
    },
    methods: {
      // 编辑的链接生成
      getRouterLink(row) {
        this.$router.push({
          path: '/Seal/Create2',
          query: {
            applyId: row.flow.applyId,
          }
        })
      },
      // 详情
      projectDetail(applyId, tableType) {
        // ajax.get("/seal/detail/" + sealId, "", (res) => {
        //   this.admin = res.vo.admin
        // })
        let _projectTable = {
          status: true,
          applyId,
          tableType,
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      sealUse(row) {
        ajax.post('/seal/confirm/add/destroy', {
          sealAddApprovalId: row.id,
          type: row.type
        }, (res) => {
          this.$message.success("操作成功")
          this.getLists()
        })
      },
      startCreate() {
        this.$router.push("/Seal/Create2")
      },
      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/seal/addordestroy/approval/list', {
          'depId': this.depId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'depId'() {
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/seal/operatelist.vue